// @flow
import styled from "styled-components";

export const TradeTitleStyled = styled.h3`
	font-size: 16px;
	font-weight: 900;
	color: #7F8A90;
`;

export default TradeTitleStyled;